import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import _ from "lodash";
import { useSelector } from "react-redux";
import confetti from "canvas-confetti";

export default function Dashreport({ metrics, workHours, dashboardRow = false }) {

  const userProfile = useSelector((state) => state.user.userinfo);
  // Use provided workHours if available, otherwise fallback to userProfile's workHours
  const memberWorkHours = workHours || userProfile.workHours;

  const handleInvoiceClick = (e) => {
    e.preventDefault(); // Prevent immediate navigation

    // Get the position of the clicked element
    const rect = e.currentTarget.getBoundingClientRect();
    const x = (rect.left + rect.width / 2) / window.innerWidth;
    const y = (rect.top + rect.height / 2) / window.innerHeight;

    // Enhanced confetti animation
    confetti({
      particleCount: 150,
      spread: 90,
      startVelocity: 30,
      gravity: 0.8,
      ticks: 200,
      origin: {
        x: x,
        y: y
      },
      colors: ['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#ffeaa7', '#dda0dd', '#98d8c8']
    });

    // Second burst for more dramatic effect
    setTimeout(() => {
      confetti({
        particleCount: 50,
        spread: 45,
        startVelocity: 20,
        origin: {
          x: x,
          y: y
        },
        colors: ['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#ffeaa7', '#dda0dd', '#98d8c8']
      });
    }, 500);

    // Open PDF after animation (2 seconds delay)
    setTimeout(() => {
      window.open(`https://portalbackend.gentrickstaffing.com/invoice/${metrics.InvoiceYear && typeof metrics.InvoiceYear === 'string' ? metrics.InvoiceYear.split('-')[1] : ''}/${metrics.CurrentInvoiceNo}.pdf`, '_blank', 'noopener,noreferrer');
    }, 2000);
  };

  const formatRemainingLeave = (hours) => {
    // Split workHours into hours and minutes
    const workHoursInMinutes = Math.floor(memberWorkHours) * 60 + Math.round((memberWorkHours % 1) * 100); // Convert 7.30 to 450 minutes (7 hours 30 minutes)

    // Convert remaining hours into total minutes
    const totalMinutes = hours * 60; // Convert the total hours to minutes

    // Calculate full days
    const days = Math.floor(totalMinutes / workHoursInMinutes);
    // Calculate remaining minutes after full days
    const remainingMinutes = totalMinutes % workHoursInMinutes;

    // Convert remaining minutes to hours and minutes
    const remainingHours = Math.floor(remainingMinutes / 60);
    const remainingMins = Math.round(remainingMinutes % 60); // Round the remaining minutes to avoid floating-point issues

    return `${days}day ${remainingHours}hr ${remainingMins}min`;
  };
  console.log("Metrics in Dashreport:", metrics);

  const loadingShell = dashboardRow ? "flex flex-col w-full" : "";
  const loadingInnerMin = dashboardRow
    ? "min-h-[calc(21rem+8px)] w-full"
    : "min-h-[200px]";

  if (_.isEmpty(metrics)) {
    return (
      <div className={`relative min-w-0 flex-1 group/dashboard-dashreport-loading ${loadingShell}`}>
        <div
          className="absolute -inset-[1px] bg-gradient-to-r from-blue-600/40 via-indigo-600/40 to-blue-600/40 rounded-2xl blur-sm opacity-50 group-hover/dashboard-dashreport-loading:opacity-80 transition duration-500 pointer-events-none"
          aria-hidden="true"
        />
        <div
          className={`relative w-full ${loadingInnerMin} flex items-center justify-center rounded-2xl border-2 border-blue-500/20 dark:border-blue-400/20 bg-white/70 dark:bg-black/40 backdrop-blur-3xl shadow-[0_15px_35px_-10px_rgba(0,0,0,0.4)] font-medium dark:text-gray-100`}
        >
        <svg
          aria-hidden="true"
          className="w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
          viewBox="0 0 100 101"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
            fill="currentColor"
          />
          <path
            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
            fill="currentFill"
          />
        </svg>
        </div>
      </div>
    );
  }
  else {
    const loadedShell = dashboardRow ? "flex flex-col w-full" : "";
    const loadedInner = dashboardRow
      ? "relative w-full min-h-[calc(21rem+8px)] flex flex-col pr-9 gap-2 px-5 py-4 rounded-2xl border-2 border-blue-500/20 dark:border-blue-400/20 bg-white/70 dark:bg-black/40 backdrop-blur-3xl shadow-[0_15px_35px_-10px_rgba(0,0,0,0.4)] font-medium dark:text-gray-100"
      : "relative w-full pr-9 gap-2 px-5 py-4 rounded-2xl border-2 border-blue-500/20 dark:border-blue-400/20 bg-white/70 dark:bg-black/40 backdrop-blur-3xl shadow-[0_15px_35px_-10px_rgba(0,0,0,0.4)] font-medium dark:text-gray-100";

    return (
      <div className={`relative min-w-0 flex-1 group/dashboard-dashreport ${loadedShell}`}>
        <div
          className="absolute -inset-[1px] bg-gradient-to-r from-blue-600/40 via-indigo-600/40 to-blue-600/40 rounded-2xl blur-sm opacity-50 group-hover/dashboard-dashreport:opacity-80 transition duration-500 pointer-events-none"
          aria-hidden="true"
        />
        <div className={loadedInner}>
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-gray-800 dark:text-gray-400 font-bold">
            Attendance
          </h3>
        </div>

        <div className="space-y-2">
          <div className="grid grid-cols-2 gap-3">
            {/* Left Column */}
            <div className="space-y-2">
              {/* Daily Average Hour */}
              <div className=" p-2 rounded-xl border border-blue-200/50 dark:border-blue-800/50 hover:shadow-sm transition-all duration-200">
                <div className="flex items-center space-x-2">
                  <div className="p-1  rounded">
                    <svg
                      className="w-5 h-5 text-blue-500"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2.5"
                        d="M12 8v4l3 3m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                      />
                    </svg>
                  </div>
                  <div className="flex-1">
                    <p className="font-semibold text-xs text-gray-700 dark:text-gray-400">
                      Daily Average Hour
                    </p>
                    <p className=" text-xl font-semibold text-gray-800 dark:text-gray-400">
                      {/* {metrics?.AvgHours && metrics.AvgHours !== "NaN:NaN"
                        ? `${metrics.AvgHours}h`
                        : "00:00h"} */}

                      {metrics?.AvgHours && !isNaN(metrics.AvgHours)
                        ? `${metrics.AvgHours}%`
                        : "0%"}

                    </p>
                  </div>
                </div>
              </div>

              {/* Average Hour */}
              <div className=" p-2 rounded-xl border border-green-200/50 dark:border-green-800/50 hover:shadow-sm transition-all duration-200">
                <div className="flex items-center space-x-2">
                  <div className="p-1  rounded">
                    <svg
                      className="w-5 h-5 text-green-500"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2.5"
                        d="M12 8v4l3 3m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                      />
                    </svg>
                  </div>
                  <div className="flex-1">
                    <p className="font-semibold text-xs text-gray-700 dark:text-gray-400">
                      Average Hour
                    </p>
                    <p className="text-xl font-semibold text-green-600 dark:text-green-400">
                      {metrics?.AvgGivenHours && !isNaN(metrics.AvgGivenHours)
                        ? `${metrics.AvgGivenHours}%`
                        : "0%"}
                    </p>
                  </div>
                </div>
              </div>

              {/* Overtime */}
              <div className=" p-2 rounded-xl border border-red-200/50 dark:border-red-800/50 hover:shadow-sm transition-all duration-200">
                <div className="flex items-center space-x-2">
                  <div className="p-1  rounded">
                    <svg
                      className="w-5 h-5 text-red-500"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2.5"
                        d="M12 8v4l3 3m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                      />
                    </svg>
                  </div>
                  <div className="flex-1">
                    <p className="font-semibold text-xs text-gray-700 dark:text-gray-400">
                      Overtime
                    </p>
                    <p className="text-xl font-semibold text-red-600 dark:text-red-400">
                      {`${metrics.OvertimeHours}h`}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="space-y-2">
              {/* Average Check-in */}
              <div className=" p-2 rounded-xl border border-blue-200/50 dark:border-blue-800/50 hover:shadow-sm transition-all duration-200">
                <div className="flex items-center space-x-2">
                  <div className="p-1  rounded">
                    <svg
                      className="w-5 h-5 text-blue-500"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2.5"
                        d="M16 12H4m12 0-4 4m4-4-4-4m3-4h2a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-2"
                      />
                    </svg>
                  </div>
                  <div className="flex-1">
                    <p className="font-semibold text-xs text-gray-700 dark:text-gray-400">
                      Average Check-in
                    </p>
                    <p className="text-xl font-semibold text-gray-800 dark:text-gray-200">
                      {metrics?.AvgCheckInTime && moment(metrics.AvgCheckInTime, ["HH:mm", moment.ISO_8601], true).isValid()
                        ? moment.utc(metrics.AvgCheckInTime, ["HH:mm", moment.ISO_8601]).local().format("h:mm a")
                        : "00:00"}
                    </p>
                  </div>
                </div>
              </div>

              {/* Average Check-out */}
              <div className=" p-2 rounded-xl border border-red-200/50 dark:border-red-800/50 hover:shadow-sm transition-all duration-200">
                <div className="flex items-center space-x-2">
                  <div className="p-1  rounded">
                    <svg
                      className="w-5 h-5 text-red-500"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2.5"
                        d="M20 12H8m12 0-4 4m4-4-4-4M9 4H7a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h2"
                      />
                    </svg>
                  </div>
                  <div className="flex-1">
                    <p className="font-semibold text-xs text-gray-700 dark:text-gray-400">
                      Average Check-out
                    </p>
                    <p className="text-xl font-semibold text-gray-800 dark:text-gray-200">
                      {metrics?.AvgCheckOutTime && moment(metrics.AvgCheckOutTime, ["HH:mm", moment.ISO_8601], true).isValid()
                        ? moment.utc(metrics.AvgCheckOutTime, ["HH:mm", moment.ISO_8601]).local().format("h:mm a")
                        : "00:00"}
                    </p>
                  </div>
                </div>
              </div>

              {/* Remaining Leave */}
              <div className=" p-2 rounded-xl border border-yellow-200/50 dark:border-yellow-800/50 hover:shadow-sm transition-all duration-200">
                <div className="flex items-center space-x-2">
                  <div className="p-1  rounded">
                    <svg
                      className="w-5 h-5 text-yellow-500"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M5 11l7 7 7-7M12 4v13"
                      />
                    </svg>
                  </div>
                  <div className="flex-1">
                    <p className="font-semibold text-xs text-gray-700 dark:text-gray-400">
                      Remaining Leave
                    </p>
                    <p className="text-xl font-semibold text-yellow-700 dark:text-yellow-400">
                      {formatRemainingLeave(metrics.RemainingHours)}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Invoice Section */}
          {metrics.CurrentInvoiceNo && (
            <div className="mt-2 p-2  rounded-xl border border-purple-200/50 dark:border-purple-800/50 hover:shadow-sm transition-all duration-300">
              <div className="flex items-center justify-between">
                <div>

                  <Link
                    target="_blank"
                    rel="noopener noreferrer"
                    to={`https://portalbackend.gentrickstaffing.com/invoice/${metrics.InvoiceYear && typeof metrics.InvoiceYear === 'string' ? metrics.InvoiceYear.split('-')[1] : ''}/${metrics.CurrentInvoiceNo}.pdf`}
                    onClick={handleInvoiceClick}
                    className="inline-flex items-center space-x-1 text-blue-600 hover:text-blue-700 dark:text-blue-700 dark:hover:text-blue-300 font-semibold transition-colors duration-200"
                  >
                    <span className="text-md">{`${metrics.CurrentInvoiceNo}`}</span>
                    <svg
                      className="w-5 h-5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 15v2a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-2m-8 1V4m0 12-4-4m4 4 4-4"
                      />
                    </svg>
                  </Link>
                  <p className="text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">
                    {`${metrics.InvoiceYear} Salary Invoice`}
                  </p>
                </div>
                <div className="w-8 h-8 bg-blue-500 dark:bg-blue-800 rounded-full flex items-center justify-center">
                  <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
              </div>
            </div>
          )}
        </div>
        </div>
      </div>
    );
  }
}
